import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../data/baseURL";

const Solution = ({ solution }) => {
  return (
    <div className="container-fluid mt-17">
      <div className="ms-13 me-13">
        <div className="row">
          <div className="col-lg-6 position-relative">
            <div>
              <h1 className="gilroy-bold fs-56 lh-64 text-capitalize solution-heading">
                {solution?.heading}
              </h1>
              <div className="solution-h1"></div>
              <p className="fs-28 lh-40 mt-5 solution-description">
                {solution?.description}
              </p>
            </div>
            <div className="position-absolute solution-img-position">
              <LazyLoadImage
                src={`${IMAGE_BASE_URL}/${solution?.image}`}
                effect="blur"
                className="solution-img"
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row fs-20 lh-40 solution">
              <div className="col-12 col-md-6 col-lg-6">
                <Link
                  to="/solutions#our-products"
                  className="text-decoration-none text-dark"
                >
                  <p className="card-design-2">{solution?.text_one}</p>
                </Link>
                <Link
                  to="/solutions#colocation"
                  className="text-decoration-none text-dark"
                >
                  <p className="card-design-2">{solution?.text_two}</p>
                </Link>
                <Link
                  to="/solutions#build-to-suit"
                  className="text-decoration-none text-dark"
                >
                  <p className="card-design-2">{solution?.text_three}</p>
                </Link>
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <Link
                  to="/solutions#sale-and-leaseback"
                  className="text-decoration-none text-dark"
                >
                  <p className="card-design-2">{solution?.text_four}</p>
                </Link>
                <Link
                  to="/solutions#managed-services"
                  className="text-decoration-none text-dark"
                >
                  <p className="card-design-2">{solution?.text_five}</p>
                </Link>
                <Link
                  to="/industry/software-apps"
                  className="text-decoration-none text-dark"
                >
                  <p className="card-design-2">{solution?.text_six}</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solution;
